export default __webpack_public_path__ + "static/media/strasbourg21.7a697c38.jpg";